﻿{
  "favoriteBoardmakerSoftware": "любимое программное обеспечение Boardmaker",
  "planDetailsStartTrial": "Начните использование бесплатной пробной версии уже сегодня (бесплатный доступ в течение 30 дней)!",
  "community": {
    "summary": "Используйте готовые доступные учебные материалы, которыми делятся родители, воспитатели и врачи (т.е. такие же люди как Вы)! Поиск и фильтр заданий и шаблонов позволяют экономить время; найдя нужное, просто добавьте эти позиции в свою учетную запись, после чего Вы получаете возможность редактирования и использования этого контента в Вашем любимом программном обеспечении Boardmaker. Программа предлагает 60.000 БЕСПЛАТНЫХ печатных и интерактивных заданий, в ней принимает участие 500.000 членов. Почему бы Вам не присоединиться?",
    "topReasons": {
      "header": "Основные причины для регистрации в сообществе myBoardmaker Community",
      "points": [
        "Возможность делиться великолепными созданными Вами заданиями",
        "Использование мощных функций поиска",
        "Поиск заданий, созданных коллективом специалистов Boardmaker (Boardmaker Education Team)",
        "Поиск заданий, соответствующие стандартам Common Core",
        "Присоединяйтесь к группам, отвечающим Вашим интересам"
      ]
    },
    "summaryEnd": "Изучайте и делитесь интерактивными и печатными материалами, направленными на создание условий, благоприятных для реализации положительной манеры поведения и способствующих развитию навыков и независимости учащихся, и все это БЕСПЛАТНО.",
    "features": [
      {
        "featureTitle": "Поиск",
        "featureDescription": "Откройте для себя адаптированную учебную программу, визуальное расписание, коммуникативные доски, задания в соответствии с образовательными стандартами, и другие виды поддержки, разработанные и используемые родителями, врачами и педагогами."
      },
      {
        "featureTitle": "Совместное использование",
        "featureDescription": "Импортируйте созданные Вами задания, принимайте участие в обсуждениях, создавайте общие и частные группы для обмена данными и т.д."
      },
      {
        "featureTitle": "Использование",
        "featureDescription": "Сохраните свои задания в Интернете, после чего Вы можете получить к ним доступ с любого компьютера."
      },
      {
        "featureTitle": "Подключение",
        "featureDescription": "Общайтесь с лицами, преподающими тот же предмет или находящимися на том же этапе обучения, обменивайтесь идеями с родителями, сталкивающимися с аналогичными проблемами, и делитесь созданными Вами решениями."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 или позже"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 или позже"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 или позже"]
      ],
      "browser": [
        ["Chrome", "v49.0", "текущие"],
        ["Firefox", "v38.0", "текущие"],
        ["Safari", "v11.0", "текущие"],
        ["Edge", "v83.0.478.45", "текущие"],
        ["Internet Explorer", "v10.0", "v11.0 или позже"]
      ]
    }
  },
  "personal": {
    "summary": "Сейчас Вы с легкостью можете воспользоваться мощью программы Boardmaker у себя дома. Подписка на myBoardmaker для личного использования (Boardmaker Online Personal) предоставляет Вам возможность принимать активное участие в достижении успехов своим ребенком, обеспечивая единство подходов как в домашних условиях, так и в условиях пребывания в школе и лечебном учреждении (т.е. обучение происходит не только в течение учебного дня или даже учебного года). Общайтесь с другими родителями сообщества Boardmaker, делитесь своими творениями и вдохновляйтесь их идеями.",
    "topReasons": {
      "header": "Основные причины подписаться на myBoardmaker Personal",
      "points": [
        "Увлекательные и интерактивные задания на любом компьютере или iPad.",
        "Возможность распечатки заданий при необходимости",
        "Вы, как родитель, принимаете активное участие в обучении Вашего ребенка дома",
        "Берите веселые и увлекательные материалы в любое время, и создавайте или редактируйте их с любого компьютера"
      ]
    },
    "summaryEnd": "Начните использование бесплатной пробной версии уже сегодня, которое включает в себя полный доступ в течение 30 дней!",
    "features": [
      {
        "featureTitle": "Создание и редактирование",
        "featureDescription": "Создавайте и редактируйте задания с адаптированными символами, такие как визуальные расписания для планирования Вашего дня, индивидуализированные книги и учебные материалы, а также материалы, направленные на создание условий, благоприятных для реализации положительной манеры поведения! Библиотека с широким выбором из более чем 80.000 символов плюс новые символы, добавляемые каждые две недели, открывают бесконечные возможности.  Нужно больше? С помощью нашего веб-поиска Вы можете добавить любые медиафайлы в свой проект."
      },
      {
        "featureTitle": "Печать и воспроизведение",
        "featureDescription": "Печатайте свои собственные или любые другие задания, найденные в Boardmaker Community, прямо из своего веб-браузера (для последующей работы со своим ребенком). Хотите повысить уровень вовлеченности? Испытайте наши интерактивные шаблоны и задания. Дети и родители могут легко воспроизводить задания с помощью бесплатного приложения Student Center на планшете или устройстве для коммуникации."
      },
      {
        "featureTitle": "Обучение и расширение",
        "featureDescription": "Начните обучение Вашего ребенка языку и грамотности с наших трех простых в использовании учебных программ. Начните с Core First Learning – инструмента, который поможет Вашему ребенку усвоить значение и использование часто употребляемых основных слов. Идеально подходит для людей, использующих системы аугментативной коммуникации на базе основных слов, или для тех, кто учится читать! Используйте свои новые навыки для изучения литературы для соответствующего уровня обучения с помощью Book Bridge, а затем начните накапливать знания об окружающем мире, изучая историю, географию, жизнь и культуру с помощью Expedition Education."
      },
      {
        "featureTitle": "Найти и поделиться",
        "featureDescription": "Зачем изобретать велосипед? Выбирайте из более чем 60.000 БЕСПЛАТНЫХ готовых печатных и интерактивных заданий и 1.100 общественных групп, разбитых по категориям, в Boardmaker Community – крупнейшем в мире сообществе по обмену информацией такого рода. Кроме того, Вы можете загружать созданные Вами задания в свою учетную запись myBoardmaker Community и делиться ими с родителями, врачами или группой поддержки Вашего ученика."
      },
      {
        "featureTitle": "Мониторинг и отслеживание",
        "featureDescription": "Контролируйте и отслеживайте прогресс Вашего ребенка по мере выполнения им заданий для обеспечения его успеха и помощи Вам в определении наиболее эффективного подхода."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 или позже"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 или позже"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 или позже"]
      ],
      "browser": [
        ["Chrome", "v49.0", "текущие"],
        ["Firefox", "v38.0", "текущие"],
        ["Safari", "v11.0", "текущие"],
        ["Edge", "v83.0.478.45", "текущие"],
        ["Internet Explorer", "v10.0", "v11.0 или позже"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional – наиболее полная система, которая используется коррекционными педагогами, логопедами, врачами-трудотерапевтами, поведенческими терапевтами и многими другими специалистами для поиска, создания, организации и предоставления индивидуальной визуальной поддержки, коммуникации на базе символов и терапевтических мероприятий, отвечающих потребностям учащихся Вашего класса или Ваших пациентов.",
    "topReasons": {
      "header": "Основные причины подписаться на myBoardmaker Professional",
      "points": [
        "Назначение заданий учащимся и управление ими из любого места и с любого компьютера.",
        "Использование большой библиотеки типовых заданий в соответствии с образовательными стандартами и возможность создания своих собственных заданий",
        "Учащиеся могут получить доступ к обучающим заданиям с любого компьютера или iPad в школе или дома.",
        "Сбор данных и отслеживание прогресса учащихся в достижении целей  индивидуальной образовательной программы и стандартов обучения",
        "Встроенные инструменты помогают пользователю взаимодействовать с другими членами коллектива и делиться с ними своими материалами"
      ]
    },
    "summaryEnd": "Начните использование бесплатной пробной версии уже сегодня, которое включает в себя полный доступ в течение 30 дней!",
    "features": [
      {
        "featureTitle": "Создание и редактирование",
        "featureDescription": "Создавайте и редактируйте задания с адаптированными символами, такие как визуальные расписания для планирования Вашего дня, индивидуализированные книги и учебные материалы, а также материалы, направленные на создание условий, благоприятных для реализации положительной манеры поведения! Библиотека с широким выбором из более чем 80.000 символов плюс новые символы, добавляемые каждые две недели, открывают бесконечные возможности. Нужно больше? С помощью нашего веб-поиска Вы можете добавить любые медиафайлы в свой проект."
      },
      {
        "featureTitle": "Печать и воспроизведение",
        "featureDescription": "Печатайте свои собственные или любые другие задания, найденные в Boardmaker Community, прямо из своего веб-браузера (для последующей работы со своим ребенком). Хотите повысить уровень вовлеченности? Испытайте наши интерактивные шаблоны и задания. Дети и родители могут легко воспроизводить задания с помощью бесплатного приложения Student Center на планшете или устройстве для коммуникации."
      },
      {
        "featureTitle": "Обучение и расширение",
        "featureDescription": "Помогите своему учащемуся сделать следующий шаг на пути обучения, получив доступ к трем надежным учебным программам, разработанным в соответствии со стандартами. Ваша подписка на myBoardmaker включает в себя программу Boardmaker Instructional Solutions, которая содержит более 140 пошаговых планов уроков, более 1500 дифференцированных заданий в соответствии со стандартами обучения, более 300 печатных и доступных книг, инструменты управления работой в классе, викторины, игры, рецепты, уроки ремесла и многое другое!"
      },
      {
        "featureTitle": "Найти и поделиться",
        "featureDescription": "Зачем изобретать велосипед? Выбирайте из более чем 60.000 БЕСПЛАТНЫХ готовых печатных и интерактивных заданий и 1.100 общественных групп, разбитых по категориям, в Boardmaker Community – крупнейшем в мире сообществе по обмену информацией такого рода. Кроме того, Вы можете загружать созданные Вами задания в свою учетную запись myBoardmaker Community и делиться ими с родителями, врачами или группой поддержки Вашего ученика."
      },
      {
        "featureTitle": "Мониторинг и отслеживание",
        "featureDescription": "Контролируйте и отслеживайте прогресс Вашего ребенка по мере выполнения им заданий для обеспечения его успеха и помощи Вам в определении наиболее эффективного подхода."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 или позже"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 или позже"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 или позже"]
      ],
      "browser": [
        ["Chrome", "v49.0", "текущие"],
        ["Firefox", "v38.0", "текущие"],
        ["Safari", "v11.0", "текущие"],
        ["Edge", "v83.0.478.45", "текущие"],
        ["Internet Explorer", "v10.0", "v11.0 или позже"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization направлена на поддержку многопредметного коллектива и предлагает адаптированные задания,  условия, благоприятные для реализации положительной манеры поведения, и инструменты оценки прогресса в достижении стандартов и целей. \n\nОблачная система myBoardmaker обеспечивает согласованность и взаимодействие в рамках всей организации и позволяет сотрудникам работать из любой точки. Кроме того, система предоставляет сотрудникам доступ к библиотеке, включающей более 60.000 готовых заданий, трем полным учебным программам и более 80.000 картинным символам коммуникации (символы PCS), чтобы они могли начать планировать свои занятия. Теперь Ваши сотрудники могут быстро предоставлять печатные и интерактивные задания своим учащимся или клиентам, используя приложение Boardmaker Student Center для расширения возможностей обучения и терапии – и для этого достаточно всего лишь нажать на одну кнопку!\n\nКонтролируйте использование персонала и повышайте эффективность работы организации в целом благодаря возможности централизованного управления учетными записями и данными, а также использованию передовых инструментов совместной работы.",
    "topReasons": {
      "header": "Основные причины подписаться на myBoardmaker Organization",
      "points": [
        "Облачная система обеспечивает согласованность и взаимодействие в рамках всей организации и позволяет сотрудникам работать из любой точки",
        "Обширная библиотека типовых заданий, приведенных в соответствие со стандартами подготовки к поступлению в колледж, стандартами подготовки к профессиональной деятельности и стандартами Вашего штата.",
        "Учащиеся могут получить доступ к обучающим заданиям с любого компьютера и из любого места",
        "Задания могут быть связаны с целями индивидуальной образовательной программы для демонстрации успеваемости учащегося",
        "Мгновенный доступ к данным об успеваемости учащихся и использовании персонала – и все это в одной системе."
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Создание и редактирование",
        "featureDescription": "Создавайте и редактируйте задания с адаптированными символами, такие как визуальные расписания для планирования Вашего дня, индивидуализированные книги и учебные материалы, а также материалы, направленные на создание условий, благоприятных для реализации положительной манеры поведения! Библиотека с широким выбором из более чем 80.000 символов плюс новые символы, добавляемые каждые две недели, открывают бесконечные возможности. Нужно больше? С помощью нашего веб-поиска Вы можете добавить любые медиафайлы в свой проект."
      },
      {
        "featureTitle": "Печать и воспроизведение",
        "featureDescription": "Печатайте свои собственные или любые другие задания, найденные в Boardmaker Community, прямо из своего веб-браузера Хотите повысить уровень вовлеченности? Рекомендуйте коллективу испытывать наши интерактивные шаблоны и задания. Студенты могут легко воспроизводить задания с помощью бесплатного, полностью доступного приложения Student Center без необходимости подключения к Интернету."
      },
      {
        "featureTitle": "Обучение и расширение",
        "featureDescription": "Предоставьте своим сотрудникам доступ к трем надежным учебным программам, разработанным в соответствии со стандартами – они все включены в Вашу подписку на myBoardmaker Organization. Boardmaker Instructional Solutions содержит более 140 пошаговых планов уроков, более 1500 дифференцированных заданий в соответствии со стандартами обучения, более 300 печатных и доступных книг, инструменты управления работой в классе, викторины, игры, рецепты, уроки ремесла и многое другое!"
      },
      {
        "featureTitle": "Назначение и отслеживание",
        "featureDescription": "С помощью учетной записи myBoardmaker Organization сотрудники могут назначать индивидуальные задания в соответствии с уровнем образования неограниченному количеству учащихся и отслеживать их индивидуальный прогресс в соответствии с целями индивидуальной образовательной программы, а также государственными и местными стандартами. Затем они могут использовать наш инструмент ''Мониторинг прогресса'' для быстрого сравнения успеваемости своих учащихся и подготовки отчета об их успехах. Назначенные задания, выполняемые дома, также отслеживаются, таким образом, можно эффективно контролировать домашние задания и взаимодействовать с семьей ребенка для расширения обучения за пределы классной комнаты."
      },
      {
        "featureTitle": "Найти и поделиться",
        "featureDescription": "Зачем изобретать велосипед? Выбирайте из более чем 60.000 БЕСПЛАТНЫХ готовых печатных и интерактивных заданий и 1.100 общественных групп, разбитых по категориям, в Boardmaker Community – крупнейшем в мире сообществе по обмену информацией такого рода. Кроме того, Вы можете загружать созданные Вами задания в свою учетную запись myBoardmaker Community и делиться ими с родителями, врачами или группой поддержки Вашего ученика."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Сокращение затрат",
        "advantagePoints": [
          "Эксклюзивные настраиваемые пакеты для организации для 5 и более учетных записей",
          "Облачные сервисы позволяют легко передавать лицензии в рамках рабочего коллектива",
          "Ценообразование в зависимости от объемов",
          "Пакеты, включающие несколько программных продуктов",
          "Экономия при приобретении многолетней подписки"
        ]
      },
      {
        "advantageTitle": "Успех для всех",
        "advantagePoints": [
          "Научно обоснованные и готовые задания обеспечивают положительные, измеримые результаты",
          "Следуя принципам Универсальных учебных действий (УУД), наши адаптированные учебные материалы и задания позволяют достигать цели обучения людьми с различными способностями.",
          "Адаптированная учебная программа обеспечивает равный доступ для всех",
          "Ресурсы, позволяющие воплощать передовой опыт экспертов, гарантируют получение Вами максимальной отдачи от Ваших решений"
        ]
      },
      {
        "advantageTitle": "Поддерживает стандарты и требования",
        "advantagePoints": [
          "Решения, разработанные специально для обучения и оценки прогресса в достижении стандартов подготовки к поступлению в колледж и стандартов подготовки к профессиональной деятельности",
          "Широкий спектр решений, поддерживающих требования Универсальных учебных действий (УУД), закона ''Каждый ученик успешен'' и закона ''Об образовании для лиц с ограниченными возможностями''",
          "автоматическое отслеживание и представление отчетов о прогрессе в достижении целей Индивидуального плана обучения с помощью информационных панелей"
        ]
      },
      {
        "advantageTitle": "Простота внедрения в организации",
        "advantagePoints": [
          "Администраторы могут организовать учетные записи и развернуть их в сети удаленно в течение нескольких секунд",
          "Гибкие и масштабируемые варианты развертывания в организации",
          "Все ''облачные'' решения размещены в высокозащищенном центре обработки данных первого уровня",
          "Бесплатные автоматические облачные обновления, включающие новые уникальные функции и ресурсы"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 или позже"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 или позже"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 или позже"]
      ],
      "browser": [
        ["Chrome", "v49.0", "текущие"],
        ["Firefox", "v38.0", "текущие"],
        ["Safari", "v11.0", "текущие"],
        ["Edge", "v83.0.478.45", "текущие"],
        ["Internet Explorer", "v10.0", "v11.0 или позже"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Пришло новое поколение программного обеспечения Boardmaker!  Boardmaker 7 использует лучшие возможности всех предыдущих версий Boardmaker в одном мультиплатформенном многоязычном приложении.  Boardmaker 7 имеет упрощенный пользовательский интерфейс, благодаря которому все необходимые инструменты находятся под рукой.  Он содержит новейшие символы PCS, однако при этом он обратно совместим со всеми Вашими старыми досками и заданиями. Это новое программное обеспечение позволит Вам создавать и представлять адаптированные учебные программы и средства коммуникации как никогда быстро.",
    "topReasons": {
      "header": "Основные причины купить программное обеспечение Boardmaker 7",
      "points": [
        "Редактирование, печать и воспроизведение всех Ваших старых файлов Boardmaker.",
        "Интуитивно понятный, современный интерфейс со встроенными подсказками и учебными материалами",
        "Потрясающие шаблоны, которые настраиваются легко и быстро",
        "Быстрый поиск нужных Вам символов и фотографий"
      ]
    },
    "summaryEnd": "Скачайте бесплатную 30-дневную пробную версию сегодня!",
    "features": [
      {
        "featureTitle": "Открывает все, что Вы сделали",
        "featureDescription": "Не потеряйте результаты своего упорного труда за предыдущие годы... благодаря программному обеспечению Boardmaker 7 Вы можете открывать любые файлы, созданные с помощью Boardmaker v5, Boardmaker v6 или Boardmaker Studio.  Преобразование происходит быстро и аккуратно, таким образом, даже сложные интерактивные задания будут работать и выглядеть точно так же, как и в оригинале."
      },
      {
        "featureTitle": "Все очень просто",
        "featureDescription": "Пользователи сказали свое слово!  Благодаря обширному тестированию пользователями, т.е. такими же людьми, как и Вы, программный интерфейс Boardmaker 7 является современным, дружественным к пользователю и интуитивно понятным.  Встроенные подсказки и учебные материалы придают пользователю уверенность в работе, позволяют ему развивать свои навыки и, самое главное, поддерживать своих учащихся."
      },
      {
        "featureTitle": "Высокая скорость / Экономия времени",
        "featureDescription": "Благодаря модернизированным шаблонам как для печатных, так и для интерактивных заданий, Вы будете поражены широтой и глубиной того, что можно создать всего за несколько минут.  Вы сможете подготовить расписание или социальную историю практически мгновенно, поэтому Ваши учащиеся получают больше внимания с Вашей стороны.  Кроме того, Boardmaker обеспечивает простоту настройки уже созданного Вами, так что Вы получаете идеальное сочетание скорости и гибкости."
      },
      {
        "featureTitle": "Превосходный поиск символов",
        "featureDescription": "Символы - это то, кто мы есть. Boardmaker 7 может похвастаться улучшенной функциональностью по поиску символов и интуитивно-понятным способом просмотра символов по категориям... но это только начало.  Вы можете искать части слов, рифмованные слова, отдельные фонемы и согласные/гласные. Это самый мощный инструмент поиска!  А если Вам не удалось найти специальный символ, встроенная функция веб-поиска и камера позволят быстро и легко добавлять фотографии."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 или позже"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 или позже"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 или позже"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["ОС Windows", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 и выше"],
        ["Android", "Устройства Tobii Dynavox T-Series", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
